.klix-container
  display: flex
  justify-content: center
  margin-top: 32px
  background-color: white
  padding: 16px
  font-family: "system-ui"

  .klix-input-container input,
  .klix-input-container span
    font-size: 24px

  .klix-input-row > div:first-child,
  .klix-loan-block div:first-child
    font-weight: 600
    font-size: 18px
    color: #626270

  .klix-info-block,
  .klix-range-block
    border-bottom: 1px solid #ededed

  .klix-disclaimer,
  .klix-input-container
    background-color: #f9f9f9

  .klix-container-inner
    max-width: 1000px

  .klix-logo
    display: flex
    justify-content: center

  .klix-input-container,
  .klix-input-row
    display: flex
    justify-content: space-between
    align-items: center

  .klix-input-container
    padding: 4px 16px
    width: 140px
    border-radius: 2px

  .klix-input-container input
    font-weight: 500
    border: 0
    color: #131313
    background-color: transparent
    width: 80px

  .klix-input-container input:focus-visible
    outline: 0

  .klix-input-container span
    color: #bfbfbf

  .klix-input-row
    align-items: center
    margin-bottom: 16px

  .klix-loan-block,
  .klix-range-values
    justify-content: space-between
    display: flex

  .klix-loan-block
    padding: 32px 8px
    align-items: center

  .klix-info-block div:last-child,
  .klix-loan-block div:last-child
    font-size: 24px
    font-weight: 500
    color: #131313

  .klix-range-block
    padding: 16px 8px

  .klix-range-values
    align-items: center
    font-size: 12px
    color: #626270
    margin-top: 16px

  .klix-info-block
    display: flex
    justify-content: space-between
    align-items: center
    padding: 8px

  .klix-info-block div:first-child
    font-weight: 600
    color: #626270

  .klix-disclaimer
    color: #626270
    font-weight: 400
    font-size: 10px
    line-height: 12px
    padding: 8px

  .noUi-pips,
  .noUi-value-sub
    color: #ccd8e1

  .noUi-target,
  .noUi-target *
    -webkit-touch-callout: none
    -webkit-tap-highlight-color: transparent
    -webkit-user-select: none
    -ms-touch-action: none
    touch-action: none
    -ms-user-select: none
    -moz-user-select: none
    user-select: none
    -moz-box-sizing: border-box
    box-sizing: border-box

  .noUi-target
    position: relative

  .noUi-base,
  .noUi-connects
    width: 100%
    height: 100%
    position: relative
    z-index: 1

  .noUi-handle,
  .noUi-marker,
  .noUi-pips,
  .noUi-value
    position: absolute

  .noUi-connects
    overflow: hidden
    z-index: 0
    border-radius: 0

  .noUi-connect,
  .noUi-origin
    will-change: transform
    position: absolute
    z-index: 1
    top: 0
    right: 0
    height: 100%
    width: 100%
    -ms-transform-origin: 0 0
    -webkit-transform-origin: 0 0
    -webkit-transform-style: preserve-3d
    transform-origin: 0 0
    transform-style: flat

  .noUi-horizontal .noUi-origin
    height: 0

  .noUi-touch-area
    height: 100%
    width: 100%

  .noUi-state-tap .noUi-connect,
  .noUi-state-tap .noUi-origin
    -webkit-transition: transform 0.3s
    transition: transform 0.3s

  .noUi-state-drag *
    cursor: inherit !important

  .noUi-horizontal
    height: 8px

  .noUi-horizontal .noUi-handle
    width: 24px
    height: 24px
    right: -12px
    top: -8px
    transition: 0.2s ease-in-out

  .noUi-horizontal .noUi-handle:hover
    box-shadow: 0 0 0 4px rgba(0, 148, 255, 0.2)

  .noUi-target
    background: #CFEBFF
    border-radius: 0
    cursor: pointer

  .noUi-connect
    background: #0068BE

  .noUi-handle
    -webkit-backface-visibility: hidden
    backface-visibility: hidden
    background-color: #0068BE
    border-radius: 100%
    cursor: pointer

  .noUi-marker,
  .noUi-marker-large,
  .noUi-marker-sub
    background: #ccd8e1

  .noUi-pips,
  .noUi-pips *
    -moz-box-sizing: border-box
    box-sizing: border-box

  .noUi-value
    white-space: nowrap
    text-align: center

  .noUi-value-sub
    font-size: 10px

  .noUi-pips-horizontal
    padding: 10px 0
    height: 80px
    top: -14px
    left: 0
    width: 100%

  .noUi-value-horizontal
    display: none

  .noUi-marker-horizontal.noUi-marker
    margin-left: -1px
    width: 2px
    height: 5px

  .noUi-marker-horizontal.noUi-marker-sub
    height: 10px

  .noUi-marker-horizontal.noUi-marker-large
    height: 16px


  .grace-round-block
    padding: 12px 24px
    border-radius: 8px
    border: 0.5px solid #e6f4ff
    background: #f2f9ff

  .grace-content-block
    display: flex
    flex-direction: column
    justify-content: center
    gap: 4px

  .grace-content-block > div
    align-self: center

  .klix-info-block.klix-grace-text-block
    border-bottom: none
    padding-bottom: 0

  .klix-info-block.klix-grace-text-block.show
    display: block

  .klix-info-block.klix-grace-text-block.hide
    display: none


  .klix-term-range-block.hide,
  .klix-downpayment-range-block.hide,
  .fixed-term .hide
    display: none


  .klix-grace-text-title
    color: #131313 !important
    font-size: 19px
    font-style: normal
    font-weight: 700
    line-height: 140% /* 19.6px */
    letter-spacing: 0.1px
    text-align: center

  .klix-grace-text
    color: #131313 !important
    font-size: 15px !important
    font-style: normal
    font-weight: 500
    line-height: 140% /* 16.8px */
    letter-spacing: 0.1px
    text-align: center


  .or-block
    display: flex
    align-items: center
    gap: 12px
    justify-content: center
    margin: 16px 0

  .or-middle-line
    border-top: 2px solid #d5e3ed
    width: 50%

  .or-text
    color: #222425
    font-size: 20px
    font-style: normal
    font-weight: 800
    line-height: 140% /* 22.4px */
    letter-spacing: 0.1px


  .custom-logo
    max-width: 210px
    max-height: 70px

  &.mobile-view
    margin-top: 0
    padding: 16px 0 0

    .klix-input-row > div:first-child,
    .klix-loan-block div:first-child
      font-weight: 600
      font-size: 16px
      color: #626270

    .klix-input-container
      padding: 4px 12px
      width: 75px

    .noUi-horizontal
      height: 5px

      .noUi-handle
        width: 18px
        height: 18px
        right: -9px
        top: -7px

      .noUi-marker-horizontal.noUi-marker-large
        height: 13px

    .klix-input-container
      input
        font-size: 16px
      span
        font-size: 18px

    .klix-input-container
      input
        width: 55px
        &.klix-term-value
          width: 35px
    
    .klix-info-block
      padding: 8px 0
      margin: 0 16px

      &.last-child
        padding: 8px 16px
        margin: 0

      div
        &:first-child
          font-size: 14px
        &:last-child
          font-size: 16px

    .klix-loan-block div
      &:first-child
        font-size: 14px
      &:last-child
        font-size: 16px

    .klix-loan-block
      padding: 24px 8px 8px

    .klix-range-block
      margin: 12px 0 8px
      padding: 0 16px 8px
